import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { calculateAmericanOdds } from 'src_common/common/calculateAmericanOdds';
import { assertNever } from 'src_common/common/assertNever';
import { PriceHistoryList } from './PriceHistory.style';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';

interface PriceType {
    d: number;
    f: string;
}

type OddsFormatType = 'f' | 'd' | 'a';

const priceToString = (price: PriceType, oddsFormat: OddsFormatType): string => {
    switch (oddsFormat) {
        case 'f':
            return price.f;
        case 'd':
            return price.d.toString();
        case 'a':
            return calculateAmericanOdds(price.d);
        default: {
            return assertNever('priceToString', oddsFormat);
        }
    }
};

interface PropsType {
    selectionId: SelectionId;
}

export const PriceHistory = observer('PriceHistory', ({ selectionId }: PropsType): JSX.Element | null => {
    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const priceHistory = selectionModel.priceHistory;
    if (priceHistory.length === 0) {
        return null;
    }

    const common = useCommon();
    const isTablet = BreakpointsState.get(common).tablet.isBiggerOrEq;
    const nrPricesToShow = isTablet === true ? 3 : 2;

    const historyToDisplay = [...priceHistory].slice(0, nrPricesToShow).reverse();

    const oddsFormat = BasicDataModel.get(common).oddsFormatShort;
    const priceList = historyToDisplay.map((price) => priceToString(price.p, oddsFormat)).join(', ');

    return <PriceHistoryList data-test='price-history'>{priceList}</PriceHistoryList>;
});
